import React from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";
import onClickOutside from "react-onclickoutside";

import DropdownButton from "../Global/Dropdowns/DropdownButton";
import DropdownSection from "../Global/Dropdowns/DropdownSection";
import Icon from "../Global/Icons/Icon";

const FolderFilterDropdown = ({ onDropdownClick, dropdownActive, filterOptions, onFilterClick, activeFilter }) => {

  FolderFilterDropdown.onClickOutside = () => {
    // collapse dropdown
    onDropdownClick(false);
  };

  const dropdownContainerClasses = classNames(
    `dropdown`,
    `dropdown--with-arrow`,
    `dropdown--with-label`,
    `folder-filter`,
    `folder-filter--container`,
    // ignore outside clicks within the dropdown itself
    `ignore-react-onclickoutside`,
  );

  const dropdownClasses = classNames(
    `dropdown__menu`,
    `dropdown__menu--s`, {
      'dropdown__menu--active': dropdownActive,
    });

  return (
    <div className={dropdownContainerClasses}>
      <DropdownButton onClick={() => onDropdownClick(!dropdownActive)} label={activeFilter.label} />
      <div className={dropdownClasses}>
        {filterOptions.map(option => {
          const optionClasses = classNames(`dropdown-link faux-btn`, {
            'bg-grey--bg': option.value === activeFilter.value
          });
          return (
            <DropdownSection key={option.value}>
              <div className="d-flex align-items-center">
                <button className={optionClasses} onClick={() => onFilterClick(option)}>
                  <Icon name={option.icon} fill={option.iconFill} size="s"/>
                  <span className="folder-filter">{option.label}</span>
                </button>
              </div>
          </DropdownSection>
          );
        })}
      </div>
    </div>
  );
};

FolderFilterDropdown.propTypes = {
  onDropdownClick: PropTypes.func.isRequired,
  dropdownActive: PropTypes.bool,
  filterOptions: PropTypes.array.isRequired,
  onFilterClick: PropTypes.func.isRequired,
  activeFilter: PropTypes.object.isRequired,
};

const clickOutsideConfig = {
  handleClickOutside: () => FolderFilterDropdown.onClickOutside,
};

export default onClickOutside(FolderFilterDropdown, clickOutsideConfig);



// WEBPACK FOOTER //
// ./library/app/components/Folders/FolderFilterDropdown.js